import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { default as ProbeListContainer } from '../Project/ProjectListContainer';
import { default as ProbeCardPreviewContainer } from './ProbeCardPreviewContainer';
import { default as ProbeCardVoteContainer } from './ProbeCardVoteContainer';
import { RouteUrls } from '../../../configs/routeUrls';
import { ProjectType } from '../../../utils/enums';

export class Probe extends Component {
	render() {
		return (
			<div>
				<div>{this.props.children}</div>
				<Route
					exact
					path={RouteUrls.Probe.list.actual}
					render={(props) => (
						<ProbeListContainer
							{...props}
							type={ProjectType.Probe}
							listUrl={RouteUrls.Probe.list.actual}
							voteUrl={RouteUrls.Probe.vote}
							previewUrl={RouteUrls.Probe.preview}
						/>
					)}
				/>
				<Route
					exact
					path={RouteUrls.Probe.list.finished}
					render={(props) => (
						<ProbeListContainer
							{...props}
							type={ProjectType.Probe}
							listUrl={RouteUrls.Probe.list.actual}
							voteUrl={RouteUrls.Probe.vote}
							previewUrl={RouteUrls.Probe.preview}
						/>
					)}
				/>
				<Route path={`${RouteUrls.Probe.preview}/:id`} component={ProbeCardPreviewContainer} />
				<Route path={`${RouteUrls.Probe.vote}/:id`} component={ProbeCardVoteContainer} />
			</div>
		);
	}
}
